import label from "@/lang/StaticLabels.js";

// PSALE Navbar  - بازرگانی و فروش -----------------------------------------------
let navItems = [
  {
    title: label.modules.psale,
    icon: "mdi-map-marker-radius",
    to: false,
  },
  {
    to: "PSALEDashboard",
    label: label.menu.dashboard,
    icon: "pi pi-home",
    active: false,
    subItems: false,
    divider: true,
  },
  {
    to: null,
    label: label.menu.baseInformation,
    icon: "pi pi-database",
    active: false,
    subItems: [
      {
        to: "PSALESaleType",
        label: label.menu.saleType,
        metaLabel: label.page.saleType,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      {
        to: "PSALESeller",
        label: label.menu.salesManager,
        metaLabel: label.page.salesManager,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      {
        to: "PSALESalesAgents",
        label: label.menu.salesAgents,
        metaLabel: label.page.salesAgents,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      {
        to: "PSALESalePricePolicyList",
        label: label.menu.salePricePolicy,
        metaLabel: label.page.salePricePolicy,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      // {
      //   to: "PSALEDiscountPolicyList",
      //   label: label.menu.discountPolicy,
      //   metaLabel: label.page.discountPolicy,
      //   icon: "mdi-subdirectory-arrow-left",
      //   active: false,
      //   subItems: [],
      // },
      {
        to: "PSALEGiftsPolicyList",
        label: label.menu.giftsPolicy,
        metaLabel: label.page.giftsPolicy,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      {
        to: "PSALESaleAddMinusList",
        label: label.menu.saleAddMinus,
        metaLabel: label.page.saleAddMinus,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      {
        to: "PSALEServiceGroup",
        label: label.menu.serviceGroup,
        metaLabel: label.page.serviceGroup,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      {
        to: "PSALEService",
        label: label.menu.service,
        metaLabel: label.page.service,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      // {
      //   to: "PSALESampleExcelFile",
      //   label: label.menu.sampleExcelFiles,
      //   metaLabel: label.page.sampleExcelFiles,
      //   icon: "mdi-subdirectory-arrow-left",
      //   active: false,
      //   subItems: [],
      // },
      {
        to: "PSALESystemSetting",
        label: label.menu.settings,
        metaLabel: label.page.saleSetting,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
    ],
  },
  {
    to: null,
    label: label.menu.operation,
    icon: "mdi-wrench-outline",
    active: false,
    subItems: [
      {
        to: null,
        label: label.menu.preFactor,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [
          {
            to: "PSALEPreFactorAdd",
            label: label.menu.addPreFactor,
            metaLabel: label.page.addPreFactor,
            icon: "mdi-circle-small",
          },
          {
            to: "PSALEPreFactorList",
            label: label.menu.preFactorList,
            metaLabel: label.page.preFactor,
            icon: "mdi-circle-small",
          },
        ],
      },
      {
        to: null,
        label: label.menu.saleFactor,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [
          {
            to: "PSALESaleFactorAdd",
            label: label.menu.addSaleFactor,
            metaLabel: label.page.addSaleFactor,
            icon: "mdi-circle-small",
          },
          {
            to: "PSALESaleFactorList",
            label: label.menu.saleFactorList,
            metaLabel: label.page.saleFactor,
            icon: "mdi-circle-small",
          },
          {
            to: "PSALEConfirmSaleFactorCartable",
            label: label.menu.confirmSaleFactorCartable,
            metaLabel: label.page.confirmSaleFactorCartable,
            icon: "mdi-circle-small",
          },
          {
            to: "PSALESortSaleFactor",
            label: label.menu.sortSaleFactor,
            metaLabel: label.page.sortSaleFactor,
            icon: "mdi-circle-small",
          },
        ],
      },
      {
        to: null,
        label: label.menu.returnSaleFactor,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [
          {
            to: "PSALEReturnSaleFactorAdd",
            label: label.menu.addReturnSaleFactor,
            metaLabel: label.page.addSaleFactor,
            icon: "mdi-circle-small",
          },
          {
            to: "PSALEReturnSaleFactorList",
            label: label.menu.returnSaleFactorList,
            metaLabel: label.page.returnSaleFactor,
            icon: "mdi-circle-small",
          },
          {
            to: "PSALEConfirmReturnSaleFactorCartable",
            label: label.menu.confirmReturnSaleFactorCartable,
            metaLabel: label.page.confirmReturnSaleFactorCartable,
            icon: "mdi-circle-small",
          },
        ],
      },
      {
        to: null,
        label: label.menu.managementCartable,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [
          {
            to: "PSALEManagementCartableSale",
            label: label.menu.saleFactor,
            metaLabel: label.page.managementCartableSale,
            icon: "mdi-circle-small",
          },
          {
            to: "PSALEManagementCartableSaleReturn",
            label: label.menu.saleReturn,
            metaLabel: label.page.managementCartableSaleReturn,
            icon: "mdi-circle-small",
          },
        ],
      },
    ],
  },
  {
    to: null,
    label: label.menu.reports,
    icon: "mdi-chart-bar-stacked",
    active: false,
    subItems: [
      {
        to: "PSALESalesOfficeReport",
        label: label.menu.salesOfficeReport,
        metaLabel: label.page.salesOfficeReport,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      {
        to: null,
        label: label.menu.commodity,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [
          {
            to: "PSALESaleReportByProduct",
            label: label.menu.saleReportByProduct,
            metaLabel: label.page.saleReportByProduct,
            icon: "mdi-circle-small",
          },
          {
            to: "PSALESalesQuantityReport",
            label: label.menu.salesQuantityReport,
            metaLabel: label.page.salesQuantityReport,
            icon: "mdi-circle-small",
          },
          {
            to: "PSALECustomerSalesSingleProduct",
            label: label.menu.customerSalesSingleProductReport,
            metaLabel: label.page.customerSalesSingleProductReport,
            icon: "mdi-circle-small",
          },
        ],
      },
      {
        to: null,
        label: label.menu.customer,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [
          {
            to: "PSALEAggregatedCustomerProductSales",
            label: label.menu.aggregatedCustomerProductSalesReport,
            metaLabel: label.page.aggregatedCustomerProductSalesReport,
            icon: "mdi-circle-small",
          },
          {
            to: "PSALECustomerCommoditySales",
            label: label.menu.customerCommoditySalesReport,
            metaLabel: label.page.customerCommoditySalesReport,
            icon: "mdi-circle-small",
          },
          {
            to: "PSALESalesStatisticsByCustomers",
            label: label.menu.salesStatisticsByCustomers,
            metaLabel: label.page.salesStatisticsByCustomersReport,
            icon: "mdi-circle-small",
          },
          {
            to: "PSALECustomerProfitReport",
            label: label.menu.customerProfit,
            metaLabel: label.page.customerProfitReport,
            icon: "mdi-circle-small",
          },
        ],
      },
      {
        to: null,
        label: label.menu.salesManager,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [
          {
            to: "PSALEBasedOnSaleManagerReport",
            label: label.menu.basedOnSaleManagerReport,
            metaLabel: label.page.basedOnSaleManagerReport,
            icon: "mdi-circle-small",
          },
          {
            to: "PSALECustomerSalesReport",
            label: label.menu.customerSalesReport,
            metaLabel: label.page.customerSalesReport,
            icon: "mdi-circle-small",
          },
          {
            to: "PSALECreditorsAndDebtorsReport",
            label: label.menu.creditorsAndDebtorsReport,
            metaLabel: label.page.creditorsAndDebtorsReport,
            icon: "mdi-circle-small",
          },
          {
            to: "PSALESalesManagerCollaborationPercentageReport",
            label: label.menu.salesManagerCollaborationPercentageReport,
            metaLabel: label.page.salesManagerCollaborationPercentageReport,
            icon: "mdi-circle-small",
          },
        ],
      },
      {
        to: null,
        label: label.menu.salesProfit,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [
          {
            to: "PSALEProductProfitReport",
            label: label.menu.productProfitReport,
            metaLabel: label.page.productProfitReport,
            icon: "mdi-circle-small",
          },
          {
            to: "PSALEGrossProfitReport",
            label: label.menu.grossProfitReport,
            metaLabel: label.page.grossProfitReport,
            icon: "mdi-circle-small",
          },
          {
            to: "PSALEProductProfitByProductGroupReport",
            label: label.menu.productProfitByProductGroupReport,
            metaLabel: label.page.productProfitByProductGroupReport,
            icon: "mdi-circle-small",
          },
          {
            to: "PSALEGrossProfitByInvoiceProductCustomerReport",
            label: label.menu.grossProfitByInvoiceProductCustomerReport,
            metaLabel: label.page.grossProfitByInvoiceProductCustomerReport,
            icon: "mdi-circle-small",
          },
          {
            to: "PSALEFactorProfitReport",
            label: label.menu.factorProfit,
            metaLabel: label.page.factorProfitReport,
            icon: "mdi-circle-small",
          },
        ],
      },
      {
        to: null,
        label: label.menu.comprehensiveReport,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [
          {
            to: "PSALEComprehensiveCommodity",
            label: label.menu.commodity,
            metaLabel: label.page.comprehensiveCommodityReport,
            icon: "mdi-circle-small",
          },
          {
            to: "PSALEComprehensiveFactorReport",
            label: label.menu.factor,
            metaLabel: label.page.comprehensiveFactorReport,
            icon: "mdi-circle-small",
          },
        ],
      },
      {
        to: null,
        label: label.menu.other,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [
          {
            to: "PSALEAdditionsDeductions",
            label: label.menu.additionsDeductions,
            metaLabel: label.page.additionsDeductionsReports,
            icon: "mdi-circle-small",
          },
          {
            to: "PSALEAwardsGivenReport",
            label: label.menu.awardsGiven,
            metaLabel: label.page.awardsGivenReport,
            icon: "mdi-circle-small",
          },
        ],
      },
      {
        to: "PSALESaleByAgentReport",
        label: label.menu.saleByAgentReport,
        metaLabel: label.page.saleByAgentReport,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      {
        to: "PSALESaleByVisitorReport",
        label: label.menu.saleByVisitorReport,
        metaLabel: label.page.saleByVisitorReport,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
    ],
  },
];

export default navItems;
